// utils/permissions.js
export const hasPermission = (key, action = "view") => {
  try {
    const admin = JSON.parse(localStorage.getItem("admin"));
    return admin?.role === "superadmin" || admin?.permissions?.[key]?.[action];
  } catch {
    return false;
  }
};
